import InterviewQuestions from './InterviewQuestions';
export default InterviewQuestions;